var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { slot: "pageContent" }, slot: "pageContent" }, [
    _c("div", { staticClass: "listPage overflow-hidden px-3" }, [
      _c(
        "div",
        {
          staticClass: "mt-2",
          attrs: { title: _vm.$t("entities_setting_tb.cit") },
        },
        [
          _c("b-row", [
            _c(
              "div",
              {
                staticClass: "ml-2 mb-5 alert d-flex align-items-center",
                staticStyle: {
                  color: "#000000",
                  "background-color": "rgb(236,236,236)",
                },
                attrs: { role: "alert" },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("entities_setting_tb.description.corporate_psp")
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _vm._l(_vm.options, function (item, index) {
                return _c(
                  "b-col",
                  { key: index, staticClass: "form-group", attrs: { sm: "3" } },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: { value: 1, "unchecked-value": 0 },
                        model: {
                          value: _vm.selectedValues[item.Name],
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedValues, item.Name, $$v)
                          },
                          expression: "selectedValues[item.Name]",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("rights.db_rights." + item.Name) ===
                                "rights.db_rights." + item.Name
                                ? item.Name
                                : _vm.$t("rights.db_rights." + item.Name)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-3 justify-item-end responsive-button",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateConfigurationTB()
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }